export default "__VITE_ASSET__d66c8f4b__"